A reference to a person associated with an object.
